import { Card, CardBody, CardHeader, CardTitle, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2'
import DataTable from 'react-data-table-component';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState, useMemo } from "react";
import { Api } from '../../componentes/Api';
import Moment from "moment";

import * as XLSX from "xlsx"
import * as moment from "moment";


import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'



const modeloDatos = {
    citaID: 0,
    nombrePaciente: "",
    telefono: 0,
    nombreTratamiento: "",
    fecha: new Date,
    hora: "",
    nombreEspecialista: "",
    comentario: "",
    confirmacionCita: true,
    notificacionCorreo: false,
    notificacionWhatsapp: true,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}


const ReporteCitas = () => {
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [pendiente, setPendiente] = useState(false);
    const [vercal, setvercal] = useState(true);
    const [tabla, setTabla] = useState([]);
    const [EmpresaD, setEmpresaD] = useState([]);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Impresion, setImpresion] = useState(false);
    const [R_API, setR_API] = useState("")
    const [verModalImpresion, setVerModalImpresion] = useState(true);
    const [imageSrc, setImageSrc] = useState("");
    const [ListaProd, SetListaProd] = useState([]);
    const [Prod, SetProd] = useState(0);

let correo = JSON.parse(user);
    let EmpresaID = JSON.parse(user).empresaID;

    const Empresa = async () => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + correo.empresaID );
        if (response.ok) {
            let data = await response.json()
            setEmpresaD(data[0])
        }
     

    }

    const fetchImage = async () => {
        const response = await fetch(Api + "Administracion/MostraFoto/" + correo.empresaID);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };
    const buscar = () => {

        setPendiente(true)
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        let _fechaInicio = Moment(fechaInicio).format('YYYY-MM-DD')//.toLocaleDateString('es-PE', options)
        let _fechaFin =  Moment(fechaFin).format('YYYY-MM-DD') //.toLocaleDateString('es-PE', options)
        obtenerDatos(_fechaInicio, _fechaFin);
    }
    const obtenerDatos = async (fi,ff) => {
        let response = await fetch(Api + "Citas/ReporteCitas/" + fi + "/" + ff + "/" + correo.correo);
        if (response.ok) {
            let data = await response.json()
            if (data.length < 1) {
                Swal.fire(
                    'Opps!',
                    'No se encontraron resultados',
                    'warning'
                )
           
            }
        
            setPendiente(false)
            setTabla(data);
            toEvent(data)
            setR_API(Api + "Citas/ReporteCitas/" + fi + "/" + ff + "/" + correo.correo)
            //                ).catch ((error) => {
            //    setTabla([]);
            //    Swal.fire(
            //        'Opps!',
            //        'No se pudo encontrar información',
            //        'error'
            //    )
            //})
        }
    }

        //let response = fetch(Api + "Citas/ReporteCitas/" + _fechaInicio + "/" + _fechaFin);

        //if (response.ok) {
        //    let data =  response.json()
        //    setTabla(data)
        //}
        
        


   

    const columns = [
        {
            name: 'Fecha Cita',
            selector: row => (moment(row.fecha).format("DD/MM/YYYY")),
            sortable: true,
        },
        {
            name: 'Nombre',
            selector: row => row.nombrePaciente,
            sortable: true,
        },
      
        {
            name: 'Hora',
            selector: row => row.hora ,
        },
        {
            name: 'Cita Conf',
            selector: row => row.confirmacionCita,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.confirmacionCita ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.confirmacionCita ? "Si" : "No"}</span>
                )
            }
        },
        {
            name: 'Telefono',
            selector: row => row.telefono,
        },
        {
            name: 'Tratamiento',
            selector: row => row.nombreTratamiento,
        },
        {
            name: 'Asignado A',
            selector: row => row.nombreEspecialista,
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const exportarExcel = () => {
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.json_to_sheet(tabla);

        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.writeFile(wb, "Reporte Citas.xlsx")
    }
    const obtenerProductos = async () => {
        let response = await fetch(Api + "Citas/ListaProductos/" + correo);

        if (response.ok) {
            let data = await response.json()
            var d = data.filter(x => x.empresaID == EmpresaID).map(e => e)
            SetListaProd(d)
            SetProd(d[0]?.articuloID)
        }
        }


    useEffect(() => {
        buscar()
        Empresa()
        fetchImage()
        obtenerProductos()
    }, [])

    const styles = `
    :root{
      --primary:#0d6efd; --text:#1f2937; --muted:#6b7280;
      --border:#e5e7eb; --bg:#ffffff; --stripe:#f9fafb;
    }
    *{box-sizing:border-box}
    body{ -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    .page{ max-width:900px; margin:24px auto; padding:28px; background:#fff; border:1px solid var(--border); border-radius:12px; color:var(--text); font:14px/1.5 system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,'Helvetica Neue',Arial; }
    header{ display:flex; align-items:center; gap:18px; border-bottom:2px solid var(--border); padding-bottom:16px; }
    .logo{ width:90px; height:90px; border:1px dashed var(--border); display:flex; align-items:center; justify-content:center; border-radius:10px; font-weight:700; color:var(--muted); background:linear-gradient(180deg,#fff,#f8fafc); overflow:hidden; }
    .logo img{ width:100%; height:100%; object-fit:contain; }
    .company{ flex:1; }
    .company h1{ margin:0; font-size:22px; letter-spacing:.3px; }
    .company p{ margin:.2rem 0; color:var(--muted); }
    .meta{ text-align:right; min-width:240px; }
    .meta h2{ margin:0; color:var(--primary); font-size:20px; }
    .meta .code{ font-weight:700; }
    .grid{ display:grid; grid-template-columns:1fr 1fr; gap:14px; margin:16px 0 8px; }
    .card{ border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; }
    .card h3{ margin:0 0 6px; font-size:14px; color:#111827; }
    .card p{ margin:.2rem 0; color:var(--muted); }
    table{ width:100%; border-collapse:collapse; margin-top:14px; font-size:13px; border:1px solid var(--border); border-radius:10px; overflow:hidden; }
    thead th{ text-align:left; background:#f3f4f6; color:#111827; font-weight:600; padding:10px; border-bottom:1px solid var(--border); }
    tbody td{ padding:9px 10px; border-bottom:1px solid var(--border); vertical-align:top; }
    tbody tr:nth-child(odd){ background:var(--stripe); }
    tfoot td{ padding:8px 10px; border-top:1px solid var(--border); }
    .right{text-align:right}
    .totals{ margin-top:10px; display:grid; grid-template-columns:1fr 320px; gap:12px; align-items:start; }
    .summary{ border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; }
    .summary .row{ display:flex; justify-content:space-between;  border-bottom:1px dashed var(--border);flex-wrap: nowrap; }
    .summary .row:last-child{ border-bottom:none; }
    .summary .row.total{ font-size:16px; font-weight:800; color:#111827; }
    .notes{ margin-top:14px; border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; color:var(--muted); }
    .sign{ display:grid; grid-template-columns:1fr 1fr; gap:18px; margin-top:30px; }
    .sign .line{ border-top:1px solid var(--border); padding-top:8px; text-align:center; color:var(--muted); }
    .actions{ display:flex; gap:8px; justify-content:flex-end; margin-top:10px; }
    .btn{ appearance:none; border:1px solid var(--border); background:#fff; padding:8px 12px; border-radius:8px; cursor:pointer; }
    .btn.primary{ background:var(--primary); border-color:var(--primary); color:#fff; }
    @media print{
      .page{ border:none; border-radius:0; padding:0; margin:0; }
      .actions{ display:none !important; }
      thead{ display:table-header-group; }
      tbody{ display:table-row-group; }
    }
  `;



    const imprimirRecibo = () => {
        const recibo = document.getElementById("reciboPago").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Recibo de Pago</title>");
        ventana.document.write("</head><body>");
     
        ventana.document.write(recibo);
        ventana.document.write("</body></html>");
        ventana.document.close();
        ventana.print();
    };

    const handleContextMenu = (event) => {
        event.preventDefault();
        //setMenuPosition({
        //    x: event.pageX,
        //    y: event.pageY,
        //});
    };


    const citas = [
        { id: 1, paciente: 'Juan Pérez', servicio: 'Consulta', fecha: '2025-08-21', hora: '08:00', duracionMin: 30, medico: 'Dra. Gómez' },
        { id: 2, paciente: 'Ana Ruiz', servicio: 'Control', fecha: '2025-08-22', hora: '10:30', duracionMin: 45, medico: 'Dr. Díaz' },
    ];

    const toEvent = (c) => {
        // Construir Date local (ajusta timeZone en el calendario para evitar corrimientos)
        const start = new Date(`${c.fecha}T${c.hora}:00`);
        const end = new Date(start.getTime() + (c.duracionMin ?? 30) * 60 * 1000);

        return {
            id: c.id,
            title: `${c.paciente} · ${c.servicio}`,
            start,
            end,
            extendedProps: { medico: c.medico, ...c },
        };
    };
    const events = useMemo(() => citas.map(toEvent), [/* depende de tu estado de citas */]);


    return (
        <>



            <Row>
                <Col sm={12}>
                    <Card>
                        <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                            Reporte de Citas
                        </CardHeader>
                        <CardBody>
                            <Row className="align-items-end">

                                <Col sm={2}>
                                    <FormGroup>
                                        <Label>Fecha Inicio:</Label>
                                        <DatePicker
                                            className="form-control form-control-sm"
                                            selected={fechaInicio}
                                            onChange={(date) => setFechaInicio(date)}
                                            dateFormat='dd/MM/yyyy'
                                        />
                                    </FormGroup>
                                </Col>

                                <Col sm={2}>
                                    <FormGroup>
                                        <Label>Fecha Fin:</Label>
                                        <DatePicker
                                            className="form-control form-control-sm"
                                            selected={fechaFin}
                                            onChange={(date) => setFechaFin(date)}
                                            dateFormat='dd/MM/yyyy'
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={2}>
                                    <FormGroup className="mb-3">
                                        <Label className="citas-label">
                                            <i className="fas fa-stethoscope me-2" style={{ color: "#3e80bd" }} /> Servicio
                                        </Label>

                                        <Input type="select" onChange={(e) => SetProd(e.target.value) }>
                                            {ListaProd.map(x => (
                                                <option value={x.articuloID}>{ x.descripcion}</option>
                                            ))}
                                      

                                        </Input>
                                      
                                    </FormGroup>
                                </Col>   <Col sm={2}>
                                    <FormGroup>
                                        <Button color="primary" size="sm" block onClick={buscar}>
                                            <i className="fa fa-search" aria-hidden="true"></i> Buscar
                                        </Button>
                                    </FormGroup>
                                </Col>

                                <Col sm={3}>
                                    <FormGroup>
                                        <Button color="success" size="md"   onClick={() => setImpresion(true)}>
                                            <i class="fas fa-print"></i>  
                                        </Button>
                                        <Button color="success" size="md"  onClick={exportarExcel}>
                                            <i className="fa fa-file-excel" aria-hidden="true"></i>  
                                        </Button> {" " }
                                        <Button hidden color="primary" size="md" onClick={() => setvercal(!vercal)}>
                                            <i className="fa fa-calendar" aria-hidden="true"></i>  
                                        </Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr></hr>
                            <Row>
                               
                                <div hidden={vercal}>
                                    
                                    <FullCalendar
                                        plugins={[dayGridPlugin]}
                                        initialView="dayGridMonth"
                                        timeZone="America/Santo_Domingo"
                                        headerToolbar={{ left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek,timeGridDay' }}
                                        events={events}
                                    />
                                </div>
                                <Col sm="12" hidden={!vercal}>
                                    <DataTable
                                        progressPending={pendiente}
                                        columns={columns}
                                        data={tabla.filter(x => x.tratamientoID == Prod).map(e =>e)}
                                        customStyles={customStyles}
                                    />


                                </Col>

                            </Row>

                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal className="modal-preguntas" isOpen={Impresion}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> IMPRESION  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>

                        <div onContextMenu={handleContextMenu} id="reciboPago"  >
                                <div class="printArea" style={{ backgroundColor: "none", marginLeft: "50px", marginTop: "50px" }} >
                                    <style>{styles}</style>

                                    <div className="page">
                                        <div className="actions">
                                    <button className="btn" onClick={() => imprimirRecibo()}>Imprimir</button>
                                        </div>
                                        <header>
                                            <div className="logo">
                                                <img src={imageSrc} alt="Logo" style={{ width: '200px', height: '150px' }} />
                                            </div>
                                            <div className="company" >
                                        <h2 style={{ textAlign: "left" }} >{EmpresaD.descripcion}</h2>
                                        <p>RNC: {EmpresaD.rnc}</p>
                                        <p>{EmpresaD.direccion}</p>
                                        <p>Tel: {EmpresaD.telefono} · Email: {EmpresaD.email}</p>
                                            </div>
                                            <div className="meta">
                                           

                                                <div><b>Impreso</b></div>
                                                <div><b>Fecha:</b>{moment(new Date).format("DD/MM/YYYY")}</div>
                                                <div><b>Hora:</b>{moment(new Date).format("HH:mm:SS")}</div>


                                            </div>
                                        </header>

                                       

                                        <div class="content">
                                            <h4>Reporte Citas del {moment(fechaInicio).format("DD/MM/YYYY")} hasta {moment(fechaFin).format("DD/MM/YYYY")}</h4>


                                            <div class="">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Paciente</th>
                                                            <th>Edad</th>
                                                            <th>Seguro</th>
                                                            <th>Teléfono</th>
                                                            <th>Especialista</th>
                                                            <th>Hora</th>
                                                            <th>Estudio</th>
                                                            <th>Confirmación</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody id="clientes-body">
                                                        {(tabla.length < 1) ? (
                                                            <tr>
                                                                <td colSpan="7" style={{ textAlign: "center" }}>
                                                                    Sin resultados
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            tabla.map(x => (<tr>
                                                                <td>{x.nombrePaciente}</td>
                                                                <td>{x.edad}</td>
                                                                <td>{x.nombreSeguro}</td>
                                                                <td>{x.telefono}</td>
                                                                <td>{x.nombreEspecialista}</td>
                                                                <td>{x.hora}</td>
                                                                <td>{x.nombreTratamiento}</td>
                                                                <td>{<span >{x.confirmacionCita ? "Si" : "No"}</span>}</td>
                                                            </tr>)))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                            

                                            </div>
                                        </div>

                                   


                                    </div>

                </ModalBody>

            </Modal>



        </>
    )
}

export default ReporteCitas;